import "@grapecity/wijmo.styles/wijmo.css";
import "@grapecity/wijmo.cultures/wijmo.culture.ko";
import styles from "./E3WijmoGrid.module.css";
import btnStyles from "../InputControls/E3Button.module.css";
import * as React from "react";
import PropTypes from "prop-types";

import {
  CollectionView,
  asEnum,
  DataType,
  hasClass,
  showPopup,
  hidePopup,
  saveFile,
  addClass,
  removeClass,
} from "@grapecity/wijmo";
import {
  CellType,
  DataMap,
  SelectionMode,
  CellRangeEventArgs,
} from "@grapecity/wijmo.grid";
import { FlexGrid, FlexGridColumn } from "@grapecity/wijmo.react.grid";
import { CellMaker } from "@grapecity/wijmo.grid.cellmaker";
import { FlexGridFilter } from "@grapecity/wijmo.react.grid.filter";
import * as wjcGridXlsx from "@grapecity/wijmo.grid.xlsx";
import * as wjcXlsx from "@grapecity/wijmo.xlsx";
import * as wjGrid from "@grapecity/wijmo.grid";
import {
  validate,
  getValidateObject,
  getObjectFromYml,
} from "e3-common/utils/validationUtil";

import {
  InputDate,
  InputDateTime,
  InputTime,
  ComboBox,
  AutoComplete,
  InputColor,
  InputNumber,
  DropDown,
  MultiSelect,
} from "@grapecity/wijmo.input";
import { ListBox } from "@grapecity/wijmo.react.input";
import { LOCAL_STORAGE_KEYS } from "e3-common/constants/enumerates";
import { getLocalStorageItem } from "e3-common/utils/localStorageUtil";
import E3Button from "../InputControls/E3Button";
import { E3WijmoGridContextMenu } from "../DataGrid/E3WijmoGridContextMenu";
import {
  toggleClass,
  isNumber,
  PopupPosition,
  Tooltip,
} from "@grapecity/wijmo";
import { Globalize } from "@grapecity/wijmo";
import { createBtnArea } from "../PageLayout/FormSection";
import _, { isArray, sortBy } from "lodash";
import E3Combobox from "../InputControls/E3Combobox";
import { existChk } from "e3-common/utils/controlsUtil";

import { getDate2String } from "e3-common/utils/dataUtil";

class E3WijmoGrid extends React.Component {
  useRefInput = React.createRef(FlexGrid);
  useRefDivFilter = React.createRef(FlexGrid);
  refGrid = React.createRef();
  refSelectedIndex = React.createRef(-1);
  refSearchCnt = React.createRef(0);
  columnPicker = React.createRef(null);
  dragSrc = React.createRef(null);
  dragDst = React.createRef(null);
  refProgramParam = React.createRef(null);
  refColumnGroupsTemp = React.createRef([]);

  constructor(props) {
    super(props);

    this.state = {
      chkProp: props,
      grid: null,
      source: props.source,
      data: props.data,
      columns: props.columns,
      columnGroups: props.columnGroups,
      allowAddNew: props.allowAddNew,
      allowDelete: props.allowDelete,
      allowPinning: props.allowPinning,
      selectionMode: props.selectionMode,
      onRowClick: props.onRowClick,
      onRowDoubleClick: props.onRowDoubleClick,
      onHeaderClick: props.onHeaderClick,
      onHeaderDoubleClick: props.onHeaderDoubleClick,
      sortDescriptions: props.sortDescriptions,
      groupDescriptions: props.groupDescriptions,
      trackChanges: props.trackChanges,
      filter: props.filter,
      style: props.style,
      width: props.width,
      height: props.height,
      codeList: [],
      frozenRows: props.frozenRows,
      frozenColumns: props.frozenColumns,
      combo: null,
      comboBoxData: "None,Cell,CellRange,Row,RowRange,ListBox".split(","),
      allowMerging: props.allowMerging,
      isReadOnly: props.isReadOnly,
      exportExcel: props.exportExcel,
      defaultColumn: props.defaultColumn,
      onCellUpdate: props.onCellUpdate,
      onCellEditEnding: props.onCellEditEnding,
      onCellEditEnded: props.onCellEditEnded,
      onRowAdded: props.onRowAdded,
      onDeletingRow: props.onDeletingRow,
      prepareCellForEdit: props.prepareCellForEdit,
      beginningEdit: props.beginningEdit,
      sortedColumn: props.sortedColumn,
      validateInfo: null,
      gridId: null,
      bufferedStartIndex: props.bufferedStartIndex,
      bufferedDataCount: props.bufferedDataCount,
      pageSize: props.pageSize,
      pageButtonCount: props.pageButtonCount,
      bufferedEndIndex: null,
      pageButton: [],
      activeButton: [],
      onloadedRows: props.onloadedRows,
      onFormatItem: props.onFormatItem,
      isSearchFilter: props.isSearchFilter,
      isDragColumn: props.isDragColumn,
      isDragComboBoxCheck: props.isDragComboBoxCheck,
      isAutoRowHeights: props.isAutoRowHeights,
      exportFileName: props.exportFileName,
      isContextMenu: props.isContextMenu,
      onCopying: props.onCopying,
      onPasted: props.onPasted,
      onPastedCell: props.onPastedCell,
      onPasting: props.onPasting,
      onPastingCell: props.onPastingCell,
      cssClass: props.cssClass,
      autoGenerateColumns: props.autoGenerateColumns,
      headersVisibility: props.headersVisibility,
      rowCount: 0,
      isHdrTooltip: props.isHdrTooltip,
      isTooltip: props.isTooltip,
      isRequired: props.isRequired,
      isMultiLine: props.isMultiLine,
      isWordWrap: props.isWordWrap,
      isAllowSorting: props.isAllowSorting,
      isAllowDragging: props.isAllowDragging,
      isUpdateCheck: props.isUpdateCheck,
    };

    this.clicks = 0;
  }

  componentDidMount() {}

  shouldComponentUpdate(nextProps) {
    if (this.props == nextProps) this.props = nextProps;
    else return false;
    return true;
  }
  render() {
    const { rightWrap, leftWrap } = this.props;
    return (
      <div className={styles.container}>
        {this.props.isInputFilter ? (
          <div
            ref={this.useRefDivFilter}
            className={`input-group`}
            style={{ overflow: `hidden`, whiteSpace: `nowrap` }}
          >
            {(this.state.columnGroups?.length > 0
              ? this.setFlatColumnGroups(this.state.columnGroups)
              : this.state.columns
            ).map((element, index, array) => (
              <input
                key={
                  (this.props.gridId ? this.props.gridId : `grid`) +
                  `_` +
                  String(element.binding) +
                  `_` +
                  String(index)
                }
                className={`form-control`}
                style={{
                  width: element.width,
                  display: element.visible === false ? `none` : `float`,
                }}
                onKeyUp={(e) => {
                  let filter = e.target.value?.toLowerCase(),
                    grid = this.refGrid.current,
                    rows = grid.rows;
                  for (let i = 0; i < rows.length; i++) {
                    let row = rows[i],
                      state = row.dataItem;
                    if (state == null) return;
                    let stateVisible =
                      String(state[element.binding])
                        .toLowerCase()
                        .indexOf(filter) >= 0;
                    if (stateVisible) row.visible = true;
                    else row.visible = false;
                  }
                }}
              />
            ))}
          </div>
        ) : null}
        {this.CreateGridTop(leftWrap, rightWrap)}
        <FlexGrid
          copying={this.state.onCopying}
          pasted={this.state.onPasted}
          pastedCell={this.state.onPastedCell}
          pasting={this.state.onPasting}
          pastingCell={this.state.onPastingCell}
          initialized={this.flexInitialized.bind(this)}
          scrollPositionChanged={this.onScrollPositionChanged}
          resizedColumn={this.onResizedColumn}
          itemsSource={this.state.source}
          selectionMode={this.state.selectionMode}
          allowPinning={this.state.allowPinning}
          allowAddNew={this.state.allowAddNew}
          allowDelete={this.state.allowDelete}
          quickAutoSize={this.state.quickAutoSize}
          allowMerging={this.state.allowMerging}
          // isReadOnly={this.state.isReadOnly}
          frozenRows={this.state.frozenRows}
          frozenColumns={this.state.frozenColumns}
          autoRowHeights={this.state.isAutoRowHeights}
          autoGenerateColumns={false}
          headersVisibility={this.state.headersVisibility}
          allowSorting={this.state.isAllowSorting}
          allowDragging={this.state.isAllowDragging}
          imeEnabled={true} // 첫글자 영어로 써지지 않게함
          selectionChanged={(s, e) => {
            // this.state.onRowClick && this.state.onRowClick();
            if (this.props.oneClickEdit) this.startEditing(s, e);
          }}
          formatItem={(sender, args) => {
            // ROW STATUS에 CSS 적용 (상태별 아이콘)
            const item = sender.rows[args.row]?.dataItem;
            if (
              item &&
              item?.hasOwnProperty("ROW_STATUS") &&
              sender?._cols[args.col]?.binding == "ROW_STATUS" &&
              args?._p._rng?._row >= 0
            ) {
              switch (item.ROW_STATUS) {
                case 1:
                  args.cell.className = "wj-cell grid-row-insert";
                  args.cell.innerHTML = "";
                  break;
                case 2:
                  args.cell.className = "wj-cell grid-row-update";
                  args.cell.innerHTML = "";
                  break;
                case 4:
                  args.cell.className = "wj-cell grid-row-delete";
                  args.cell.innerHTML = "";
                  break;
                default:
                  args.cell.className = "wj-cell";
                  break;
              }
            }

            const chkValue = this.props.chkValue;

            if (!chkValue) return;

            if (item) {
              const result = Object.entries(chkValue)
                .map(([key, patternObject]) => {
                  return patternObject[item?.[key]];
                })
                .filter(Boolean);

              if (args.panel.cellType === CellType.Cell) {
                if (result.length) {
                  this.setToggleClass(args.cell, result, true); // 특정 데이터 행의 className 적용
                } else {
                  this.setToggleClass(args.cell, "", true);
                }
              }
            }
          }}
          style={
            this.state.style || {
              width:
                typeof this.props.width === "number"
                  ? this.props.width + "px"
                  : this.props.width,
              height:
                typeof this.props.height === "number"
                  ? Number(this.props.height) < 100
                    ? 27 * this.props.height + "px"
                    : this.props.height + "px"
                  : this.props.height, //27: heder size
            }
          }
          childItemsPath={this.props.childItemsPath}
          {...(this.props.isRestrictedMergeManager
            ? { mergeManager: new RestrictedMergeManager() }
            : {})}
          {...(this.chkArray(this.state.columnGroups)
            ? {
                columnGroups: this.settingColumnGroups(this.state.columnGroups),
              }
            : {})}
        >
          {this.state.filter && <FlexGridFilter />}
          {!this.chkArray(this.state.columnGroups) &&
            this.chkArray(this.state.columns) &&
            this.state.columns.map((column, idx) => {
              let tmpDataMap = column.dataMap
                ? new DataMap(
                    column.dataMap,
                    column.dataMapCode,
                    column.dataMapValue
                  )
                : null;

              if (!existChk(column)) return;

              return (
                <FlexGridColumn
                  key={idx}
                  header={column.header}
                  binding={column.binding}
                  maxLength={column.maxLength}
                  minWidth={column.minWidth}
                  width={column.width ? column.width : "*"}
                  align={column.align}
                  isReadOnly={
                    column.isReadOnly ?? this.state.isReadOnly ? true : false
                  }
                  isRequired={column.isRequired ?? this.state.isRequired}
                  visible={column.visible ?? true}
                  format={column.format?.replaceAll("/", "\\/")}
                  dataType={column.dataType}
                  dataMap={tmpDataMap}
                  dataMapEditor={column.dataMapEditor}
                  allowMerging={column.allowMerging}
                  multiLine={column.multiLine ?? this.state.isMultiLine}
                  cssClass={column.cssClass}
                  wordWrap={column.wordWrap ?? this.state.isWordWrap}
                  cellTemplate={this._makeCellTemplate(column)}
                  editor={this._makeEditor(column)}
                  aggregate={column.aggregate} // footer에 합 출력
                />
              );
            })}
        </FlexGrid>
        {this.state.exportExcel ? (
          <button onClick={this.saveExcel} className="btn btn-default">
            Export
          </button>
        ) : null}
        {this.props.pagingType === "Server" && this.state.source > "" ? (
          <>
            <div className="pagingDiv_wrap">
              <div className="pagingDiv_left">
                <span className={styles.gridPagingComboTitle}>Show Rows</span>
                <E3Combobox
                  parentCodeId={"GRID_PAGE_CNT"}
                  className={styles.gridPagingCombo}
                  defaultValue={this.state.bufferedDataCount}
                  onChange={(s, e) => {
                    this.setBufferedInfo(1, Number(e.codeId));
                    setTimeout(() => {
                      this.props.bufferedSearchFunction(
                        1,
                        this.refProgramParam.current
                      );
                    }, 100);
                  }}
                />
              </div>
              <div className="pagingDiv">
                <E3Button
                  /*label={'|<<'}*/
                  colorType="default-outline"
                  iconType={"btn_pageFirst"}
                  checkAuth={false}
                  onClick={() => {
                    const info = this.getBufferedInfo();
                    if (info.idx == 1) return;
                    this.setBufferedInfo(1);
                    this.props.bufferedSearchFunction(
                      1,
                      this.refProgramParam.current
                    );
                  }}
                />
                <E3Button
                  /*label={'<<'}*/
                  colorType="default-outline"
                  iconType={"btn_prevPrev"}
                  checkAuth={false}
                  onClick={() => {
                    const info = this.getBufferedInfo();
                    const idx = info.idx - info.cnt * info.size;
                    if (idx < 1) return;
                    this.setBufferedInfo(idx);
                    this.props.bufferedSearchFunction(
                      idx,
                      this.refProgramParam.current
                    );
                  }}
                />
                <E3Button
                  /*label={'<'}*/
                  colorType="default-outline"
                  iconType={"btn_prev"}
                  checkAuth={false}
                  onClick={() => {
                    const info = this.getBufferedInfo();
                    const idx = info.idx - info.cnt;
                    if (idx < 1) return;
                    this.setBufferedInfo(idx);
                    this.props.bufferedSearchFunction(
                      idx,
                      this.refProgramParam.current
                    );
                  }}
                />
                {this.state.activeButton.map((element, index, array) => (
                  <E3Button
                    key={
                      `paging` +
                      String(element) +
                      `_` +
                      String(this.state.pageButton[index])
                    }
                    label={String(this.state.pageButton[index])}
                    checkAuth={false}
                    onClick={() => {
                      const info = this.getBufferedInfo();
                      const toPageNum = Number(this.state.pageButton[index]);
                      if (toPageNum === info.cur) return;
                      const idx =
                        (Number(this.state.pageButton[index]) - 1) * info.cnt +
                        1;
                      this.setBufferedInfo(idx);
                      this.props.bufferedSearchFunction(
                        idx,
                        this.refProgramParam.current
                      );
                    }}
                    colorType={element == 1 ? `pageOn` : `pageDefault`}
                  />
                ))}
                <E3Button
                  /*label={'>'}*/
                  colorType="default-outline"
                  iconType={"btn_next"}
                  checkAuth={false}
                  onClick={() => {
                    const info = this.getBufferedInfo();
                    const idx = info.idx + info.cnt;
                    if (idx > info.end) return;
                    this.setBufferedInfo(idx);
                    this.props.bufferedSearchFunction(
                      idx,
                      this.refProgramParam.current
                    );
                  }}
                />
                <E3Button
                  /*label={'>>'}*/
                  colorType="default-outline"
                  iconType={"btn_nextNext"}
                  checkAuth={false}
                  onClick={() => {
                    const info = this.getBufferedInfo();
                    const idx = info.idx + info.cnt * info.size;
                    if (idx > info.end) return;
                    this.setBufferedInfo(idx);
                    this.props.bufferedSearchFunction(
                      idx,
                      this.refProgramParam.current
                    );
                  }}
                />
                <E3Button
                  /*label={'>>|'}*/
                  colorType="default-outline"
                  iconType={"btn_pageEnd"}
                  checkAuth={false}
                  onClick={() => {
                    const info = this.getBufferedInfo();
                    const toPageNum = Math.ceil(info.end / info.cnt);
                    let idx = toPageNum * info.cnt + 1;
                    if (idx == info.idx || toPageNum === info.cur) return;
                    if (idx > info.end) idx = (toPageNum - 1) * info.cnt + 1;
                    this.setBufferedInfo(idx);
                    this.props.bufferedSearchFunction(
                      idx,
                      this.refProgramParam.current
                    );
                  }}
                />
              </div>
            </div>
          </>
        ) : null}
        <input
          ref={this.useRefInput}
          className="input-excel-import"
          style={{ display: "none" }}
          type="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          onChange={(e) => {
            // loadExcel은 문제가 있어서 loadExcelMakeGridData를 사용함
            // this.loadExcelMakeGridData(e.target.files[0], false, true);
            this.loadExcelMakeGridData(e.target.files[0], this.props.notMerge);
          }}
        />
        <div className="column-picker-div">
          <ListBox
            className="column-picker"
            initialized={this._initializedPicker.bind(this)}
          />
        </div>
      </div>
    );
  }

  /**
   * flexGrid 관련 함수
   *
   * init
   */

  // 그리드 첫 렌더링 시 동작
  flexInitialized(flexGrid) {
    if (this.props.headerHeight > -1)
      flexGrid.columnHeaders.rows.defaultSize = this.props.headerHeight;
    if (this?.props?.columnGroups.length > 0)
      flexGrid.columnHeaders.rows.defaultSize = 25;
    else flexGrid.rows.defaultSize = 35;
    // flexGrid.rows.defaultSize = 35;
    // 첫번째 줄 선택 해제
    flexGrid.collectionView?.moveCurrentToPosition(-1);
    // isCollapseGroupsToLevel0값이 true이면 초기 조회시 묶어서 출력함
    if (this.props.isCollapseGroupsToLevel0) flexGrid?.collapseGroupsToLevel(0);
    // flexGrid.autoSizeRows();

    setTimeout(() => {
      _autoSizeRowsAsync(flexGrid);
    }, 200);

    let tooltip = null;
    let hdrTooltip = null;
    let isHdrTooltipText = false;
    let columns = this.state.columns;

    // 그룹 컬럼 시, this.state.columns 값이 존재하지 않으므로 그룹컬럼 기준으로 다시 체크
    if (!this.chkArray(columns)) {
      columns = _findNodesWithColumns(
        this.refColumnGroupsTemp.current || [],
        [],
        true
      );
    }

    if (this.state.isTooltip) tooltip = new Tooltip();
    if (this.state.isHdrTooltip) {
      hdrTooltip = new Tooltip({
        position: PopupPosition.RightBottom,
        showAtMouse: true,
        showDelay: 600,
        cssClass: "hdr-tip",
      });

      isHdrTooltipText =
        columns?.filter((x) => {
          return x.CHToolTip;
        })?.length > 0
          ? true
          : false;
    }

    if (this.state.isContextMenu) {
      // Init Context Menu
      let fileName = this.state.exportFileName;
      if (!this.state.exportFileName) {
        fileName = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID);

        if (!fileName) {
          fileName = "TempName";
        }
      }
      new E3WijmoGridContextMenu(flexGrid, fileName);
      // End Context Menu
    }

    this.refGrid.current = flexGrid;

    /* make drag column */
    if (this.props.isDragColumn) {
      this.setState({ headersVisibility: "All" });
      flexGrid.allowDragging = wjGrid.AllowDragging.Both;

      for (let i = 0; i < 1; i++) {
        flexGrid.rowHeaders.columns.insert(0, new wjGrid.Column());
      }
    }

    // FlexGridSearch exc
    if (this.props.isSearchFilter) {
      this.props.isSearchFilter.current.control.grid = flexGrid;
      // 특정 컬럼(ROW_CHECK, ROW_STATUS)은 필터에서 제외함
      var exceptColumns = ["ROW_CHECK", "ROW_STATUS"];
      this.props.isSearchFilter.current.control._getItemText = function (e) {
        for (
          var t = [], r = this._g._getBindingColumns(), i = 0;
          i < r.length;
          i++
        ) {
          var n = r[i],
            o = n._binding;
          if (exceptColumns.includes(n.binding)) continue;
          if (o && (n.visible || this.searchAllColumns)) {
            var a = o.getValue(e);
            a = n.dataMap
              ? n.dataMap.getDisplayValue(a)
              : Globalize.format(a, n.format);
            n.isContentHtml && (a = toPlainText(a));
            a && t.push(a);
          }
        }
        return t.join(" ");
      };
    }

    if (!this.state.defaultColumn) {
      flexGrid.rowHeaders.columns.splice(0, 1);
    }

    flexGrid.formatItem.addHandler((s, e) => {
      if (e.panel.cellType == CellType.ColumnHeader) {
        // Grid Header Style 적용
        this.addHeaderStyle(e);

        // header tooltip
        if (this.state.isHdrTooltip) {
          const column = columns[e.col];

          if (isHdrTooltipText) {
            if (this.chkArray(this.state.columns) && column?.CHToolTip) {
              hdrTooltip.setTooltip(e.cell, column?.CHToolTip);
            } else {
              /**
               * Group Column일 경우 전부 다 들고와서 비교를 하고 있음
               * 향후 기능 개선이 필요
               */
              const item = columns?.find((data) => {
                return data.header === e.cell.textContent;
              });
              if (item?.CHToolTip) {
                hdrTooltip.setTooltip(e.cell, item?.CHToolTip);
              }
            }
          } else {
            hdrTooltip.setTooltip(
              e.cell,
              '<span class="col-header">' + e.getColumn().header + "</span>"
            );
          }
        }
      } else if (e.panel == s.cells) {
        if (this.state.onCellUpdate) this.state.onCellUpdate(s, e);

        // 생성된 CellMaker 선택적 제거 (multi header는 현재 기능 존재 x)
        if (this.state.columns.length) {
          this.removeCellMaker(s, e);
        }

        // memo & toolip
        if (this.state.isTooltip) {
          let item = s.rows[e.row].dataItem,
            binding = s.columns[e.col].binding,
            note = item.notes ? item.notes[binding] : null;

          this.setToggleClass(e.cell, "wj-has-notes", note != null);

          if (note != null) {
            tooltip.setTooltip(e.cell, "<b>Note:</b><br/>" + note);
          }
        }
      }
    });

    // grid copy 했을때 (Control + c)
    flexGrid.copying.addHandler((s, e) => {
      // 복사할 때
      // console.log(e);
    });

    // grid pasting 했을때 (Control + v)
    flexGrid.pasting.addHandler((s, e) => {
      // 붙여넣기 시작 시 한번
      // console.log(e);
    });

    // grid pastingCell 했을때 (Control + v)
    flexGrid.pastingCell.addHandler((s, e) => {
      // 붙여넣기 중(1)
      // 붙여넣는 data : e.data
      // console.log(e);

      /**
       * 붙여넣는 대상의 ROW_STATUS 상태값 변경 : 수정(2)
       */
      const row = s.rows[e.row]?.dataItem;
      if (row) {
        row.ROW_STATUS = 2;
        row.ROW_CHECK = true;
      }
    });

    // grid pastedCell 했을때 (Control + v)
    flexGrid.pastedCell.addHandler((s, e) => {
      // 붙여넣기 중(2)
      // 붙여넣기 전 data : e.data
      // console.log(e);
    });

    // grid pasted 했을때 (Control + v)
    flexGrid.pasted.addHandler((s, e) => {
      // 붙여넣기 끝났을 때 한번
      // console.log(e);
    });

    /* drag function */
    flexGrid.draggedRow.addHandler((s, e) => {
      const startRow = e.data.row;
      const endRow = e.row;

      if (endRow > startRow) {
        for (let i = startRow; i <= endRow; i++) {
          let rowTmp = s.rows[i]?.dataItem;
          rowTmp.ROW_STATUS = 2;
          if (this.props.isDragComboBoxCheck) rowTmp.ROW_CHECK = true;
        }
      } else {
        for (let i = endRow; i <= startRow; i++) {
          let rowTmp = s.rows[i]?.dataItem;
          rowTmp.ROW_STATUS = 2;
          if (this.props.isDragComboBoxCheck) rowTmp.ROW_CHECK = true;
        }
      }

      if (this.props.onDraggedRow) this.props.onDraggedRow(s, e);
    });
    /* drag function */

    flexGrid.cellEditEnding.addHandler((s, e) => {
      // 주요값
      var colId = e._p._cols[e.col].binding;
      var colName = e._p._cols[e.col]._hdr;
      var value = s.activeEditor.value;

      // validateInfo가 없으면 유효성 체크를 하지 않음
      if (!this.state.validateInfo) {
        if (this.state.onCellEditEnding) this.state.onCellEditEnding(s, e);
        return;
      }
      // validateInfo에 colId 존재여부 확인. 없으면 건너뜀
      else if (!this.state.validateInfo.hasOwnProperty(colId)) {
        if (this.state.onCellEditEnding) this.state.onCellEditEnding(s, e);
        return;
      }

      var validInfo = this.state.validateInfo[colId];

      // yml 파일의 컬럼 ID와 현재 셀의 컬럼 ID가 동일하면 validation 수행
      if (validInfo) {
        // validate() 수행 시 error를 throw하므로 try catch를 사용하여 alert창 띄움
        try {
          validate(getValidateObject(validInfo, colName, value));
        } catch (ex) {
          e.cancel = true;
          e.stayInEditMode = true;
          alert(ex);
        }
      }

      if (this.state.onCellEditEnding) this.state.onCellEditEnding(s, e);
    });

    flexGrid.cellEditEnded.addHandler((s, e) => {
      const column = s.columns[e.col]?.binding;
      const row = s.rows[e.row]?.dataItem;
      const editValue = row?.[column];

      // 수정 Flag 부여
      if (row && !row.ROW_STATUS && editValue !== e.data) {
        row.ROW_STATUS = 2;
        if (this.props.isUpdateCheck) row.ROW_CHECK = true;
      }

      const format = s.columns[e.col].format;
      const dataType = s.columns[e.col].dataType;
      /**
       * DataType
       * Object = 0, String = 1, Number = 2, Boolean = 3, Date = 4, Array = 5
       */
      if (format && dataType === 4) {
        const value = s.getCellData(e.row, e.col);
        s.setCellData(
          e.row,
          e.col,
          value ? Globalize.format(s.getCellData(e.row, e.col), format) : null,
          false,
          false
        );
      }

      if (this.state.onCellEditEnded) this.state.onCellEditEnded(s, e);
    });

    flexGrid.rowAdded.addHandler((s, e) => {
      if (this.state.onRowAdded) this.state.onRowAdded(s, e);
    });

    flexGrid.deletingRow.addHandler((s, e) => {
      if (this.state.onDeletingRow) this.state.onDeletingRow(s, e);
    });

    flexGrid.prepareCellForEdit.addHandler((s, e) => {
      // 컨트롤이 달력인 경우 width 값을 설정함
      if (e.panel.columns[e.col].editor?.calendar > "") {
        // e.panel.columns[e.col].editor.dropDown.style.width = ''.concat(300, 'px');
      }
      if (this.state.prepareCellForEdit) this.state.prepareCellForEdit(s, e);
    });

    flexGrid.beginningEdit.addHandler((s, e) => {
      // 컨트롤이 달력인 경우 width 값을 설정함
      if (e.panel.columns[e.col].editor?.calendar > "") {
        e.panel.columns[e.col].editor.dropDown.style.width = "".concat(
          300,
          "px"
        );
      }
      if (this.state.beginningEdit) this.state.beginningEdit(s, e);
    });

    flexGrid.sortedColumn.addHandler((s, e) => {
      if (this.state.sortedColumn) this.state.sortedColumn(s, e);
    });

    flexGrid.loadedRows.addHandler((s, e) => {
      if (this.state.onloadedRows) this.state.onloadedRows(s, e);
    });

    flexGrid.formatItem.addHandler((s, e) => {
      if (this.state.onFormatItem) this.state.onFormatItem(s, e);
    });

    // scrollPositionChanged 사용
    if (this.props.pagingType == "Buffered" || this.props.isInputFilter) {
      flexGrid.scrollPositionChanged.addHandler((s) => {
        // 버퍼드 그리드에서 사용
        if (this.props.pagingType == "Buffered") {
          //console.log(s.viewRange.bottomRow, s.rows.length - 1, this.getBufferedInfo())
          if (s.viewRange.bottomRow >= s.rows.length - 1) {
            let view = s.collectionView;
            if (view == null) return;
            let index = view.currentPosition;
            var bufferedInfo = this.getBufferedInfo();
            var cnt = bufferedInfo.cnt;
            var idx = bufferedInfo.idx + cnt;
            this.setBufferedInfo(idx, cnt);
            this.props.bufferedSearchFunction(idx, cnt);
            view.refresh();
            view.currentPosition = index;
          }
        }
        // input 태그로 필터 사용
        if (this.props.isInputFilter) {
          if (this.useRefDivFilter.current == null) return;
          this.useRefDivFilter.current.scrollLeft = Math.abs(
            s.scrollPosition.x
          );
        }
      });
    }

    // 마우스 오른쪽 클릭 이벤트 추가
    flexGrid.addEventListener(flexGrid.hostElement, "contextmenu", (e) => {
      let ht = flexGrid.hitTest(e);
      //isAllowList default true
      if (this.props.isAllowListBox) {
        if (ht.cellType == CellType.ColumnHeader) {
          if (hasClass(e.target, "wj-header")) {
            let host = this.columnPicker.current.hostElement;
            if (!host.offsetHeight) {
              showPopup(host, flexGrid.hostElement, false, true, false);
              this.columnPicker.current.focus();
            } else {
              hidePopup(host, true, true);
              flexGrid.focus();
            }
            this.columnPicker.current.focus();
            e.preventDefault();
          }
        }
      }
    });

    // 마우스 클릭 이벤트 추가
    flexGrid.addEventListener(flexGrid.hostElement, "click", (e) => {
      let ht = flexGrid.hitTest(e);
      this.refSelectedIndex.current = this.getSelectedRowIndex();

      /**
       * grid checkBox의 바깥 cell 선택하고 grid checkBox를 선택 시, checkBox의 상태값이 변경되지 않는 버그가 존재
       * grid checkBox의 바깥 cell을 선택 시, onClick event cancel
       */
      if (
        ht.target.innerHTML.indexOf("checkbox") > 0 &&
        ht.target.firstChild?.nodeName === "LABEL"
      ) {
        flexGrid.endUpdate();
        return;
      }

      const headerClick = ht.cellType == CellType.ColumnHeader ? true : false;

      const clickFunction = headerClick
        ? this.props.onHeaderClick
        : this.props.onRowClick;
      const doubleClickFunction = headerClick
        ? this.props.onHeaderDoubleClick
        : this.props.onRowDoubleClick;

      if (ht.row < 0) return;

      this.clicks++;
      if (this.clicks === 1) {
        setTimeout(() => {
          if (this.clicks === 1 && clickFunction) {
            clickFunction(ht.grid, ht);

            // 더블클릭 시, 에디터 모드가 아닌 경우에만 이벤트 추가
          } else if (
            this.clicks > 1 &&
            (headerClick || ht._target.ariaReadOnly) &&
            doubleClickFunction
          ) {
            if (ht.row === this.getSelectedRowIndex())
              doubleClickFunction(ht.grid, ht);
          }

          this.clicks = 0;
        }, 300);
      }
      //
    });

    //그리드 헤더에 체크박스 추가
    if (this.props.isAllCheckbox) {
      let chkBoxColumn = this.props.checkBoxColumn;
      flexGrid.itemFormatter = function (panel, r, c, cell) {
        if (CellType[panel.cellType] == "ColumnHeader") {
          var flex = panel.grid;
          var col = flex.columns[c];

          if (col.binding == chkBoxColumn) {
            col.allowSorting = false;

            var cnt = 0;
            for (var i = 0; i < flex.rows.length; i++) {
              if (flex.getCellData(i, c) == true) cnt++;
            }

            cell.innerHTML = '<input type="checkbox"><span></span> '; // + cell.innerHTML;
            var cb = cell.firstChild;
            cb.checked = cnt > 0;
            cb.indeterminate = cnt > 0 && cnt < flex.rows.length;

            cb.addEventListener("click", function (e) {
              flex.beginUpdate();
              for (var i = 0; i < flex.rows.length; i++) {
                flex.setCellData(i, c, cb.checked);
              }
              flex.endUpdate();
            });
          }
        }
      };
    }

    if (this.props.gridId) {
      this.setState({ gridId: this.props.gridId });
    }

    // 그리드 개인화
    var menuId = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID);
    var gridPsn = getLocalStorageItem(LOCAL_STORAGE_KEYS.GRID_PSN);
    if (gridPsn > "") {
      var gridPsnFilter = JSON.parse(gridPsn).filter((row) => {
        return row.menuId === menuId && row.gridId === this.props.gridId;
      });
      if (gridPsnFilter.length == 1) {
        this.setColumns(JSON.parse(gridPsnFilter[0].columnInfo));
        var frozenColumns = gridPsnFilter[0].frozenColumns;
        this.refGrid.current.frozenColumns =
          frozenColumns > 0 ? frozenColumns : 0;
      }
    }

    // 그리드 footer 사용여부
    if (this.props.isColumnFooters) {
      flexGrid.columnFooters.rows.push(new wjGrid.GroupRow());
      if (this.props.columnFooterName) {
        const idx = this.props.columnFooterName.idx ?? 0;
        const name = this.props.columnFooterName.name ?? "합계";
        try {
          this.refGrid.current.columnFooters.setCellData(0, idx, name);
        } catch (error) {}
      }
    }

    // mergeManager 초기화
    if (this.props.isRestrictedMergeManager) {
      flexGrid.mergeManager = new RestrictedMergeManager();
    }

    this.refGrid.current = flexGrid;
  }

  // when change scroll position
  onScrollPositionChanged(grid) {
    var vr = grid.viewRange;
    for (var r = vr.topRow; r <= vr.bottomRow; r++) {
      if (grid.rows[r]?.height == null) {
        grid.autoSizeRows(r, r);
      }
    }
  }

  // when change column size
  onResizedColumn(grid, e) {
    if (grid.columns[e.col].wordWrap) {
      _autoSizeRowsAsync(grid);
    }
  }

  // 콤보박스 첫 렌더링 시 동작
  initCombo(comboBox) {
    this.setState({ combo: comboBox });
  }

  // 콤보박스 text 처리
  onTextChanged() {
    if (this.refGrid.current) {
      let mode = asEnum(this.state.combo.selectedIndex, SelectionMode);
      this.refGrid.current.selectionMode = mode;

      this.setState({
        selectionMode: mode,
      });
    }
  }

  setDataBinding = (datasource, callback) => {
    if (!datasource) return;
    const CHILDREN_ID = this.props.childItemsPath;
    const { stat1: KEY1, stat2: KEY2 } = this.props.keyPath;
    // Tree 그리드 데이터 중복 제거
    if (CHILDREN_ID && KEY1) {
      var dupArray = [];
      var cnt = datasource.length;
      for (var i = 0; i < cnt; i++) {
        // CHILDREN_ID 에서 MENU_ID를 가져온다
        // 해당 MENU_ID를 datasource에서 찾아서 가져온다. (datasource에서는 제거)
        // 가져온 row를 CHILDREN_ID의 배열에 넣는다.
        var children = datasource[i][CHILDREN_ID]
          ? datasource[i][CHILDREN_ID].split(",")
          : "";
        if (children > "") {
          var childrenArray = [];
          for (var j = 0; j < children.length; j++) {
            var obj = datasource.filter((row) => row[KEY1] == children[j]);
            // 중복된 CHILDREN_ID가 존재할 수 있으므로 PARENT_ID 체크
            if (KEY2) {
              obj = obj.filter((row) => row[KEY2] == datasource[i][KEY1]);
            }
            if (obj.length > 0) childrenArray.push(obj[0]);
          }
          datasource[i][CHILDREN_ID] = _.orderBy(
            childrenArray,
            ["ORD"],
            ["asc"]
          );
          dupArray = [...dupArray, ...childrenArray];
        }
      }
      // 중복제거
      dupArray = dupArray.reduce(
        (acc, cur, idx, src) => (acc.includes(cur) ? acc : [...acc, cur]),
        []
      );
      // datasource에서 dupArray에 있는 MENU_ID 제거 (이미 CHILDREN_ID에 존재하기 때문)
      // dupArray.forEach((f) =>
      //     datasource.splice(
      //         datasource.findIndex((e) => e[KEY1] == f[KEY1]),
      //         1,
      //     ),
      // );
      const dupSet = new Set(dupArray.map((f) => f[KEY1]));
      datasource = _.orderBy(
        datasource.filter((e) => !dupSet.has(e[KEY1])),
        ["ORD"],
        ["asc"]
      );
      // isCollapseGroupsToLevel0값이 true이면 초기 조회시 묶어서 출력함
      if (this.props.isCollapseGroupsToLevel0)
        callback = () => this.refGrid.current?.collapseGroupsToLevel(0);
    }

    let bindingData = "";

    if (typeof datasource === "string") {
      bindingData = JSON.parse(datasource);
    } else {
      bindingData = datasource;
    }

    if (
      this.state.columns.find((c) => c.binding == this.props.checkBoxColumn)
    ) {
      bindingData.map((e, idx) => {
        //console.log(e, this.props.checkBoxColumn, e[this.props.checkBoxColumn])
        if (e[this.props.checkBoxColumn]?.length > 0) {
          if (
            e[this.props.checkBoxColumn].toLowerCase() == "true" ||
            e[this.props.checkBoxColumn].toLowerCase() == "1"
          ) {
            bindingData[idx][this.props.checkBoxColumn] = 1;
          } else if (
            e[this.props.checkBoxColumn].toLowerCase() == "false" ||
            e[this.props.checkBoxColumn].toLowerCase() == "0"
          ) {
            bindingData[idx][this.props.checkBoxColumn] = 0;
          }
        }
      });
    }

    if (this.props.isNo) {
      bindingData = bindingData.map((data, index) => {
        if (this.props.pagingType === "Server" && this.state.source > "") {
          const { idx } = this.getBufferedInfo();
          index = idx - 1 + index;
        }
        return { NO: ++index, ...data };
      });
    }

    if (this.props.validateYmlFile) {
      getObjectFromYml(this.props.validateYmlFile).then((res) => {
        this.setState({ validateInfo: res });
      });
    }

    let formatList = this.state.columns.filter((e) => e.dataType);

    // 그룹 컬럼 시, this.state.columns 값이 존재하지 않으므로 그룹컬럼 기준으로 다시 체크
    if (!this.chkArray(formatList)) {
      formatList = _findNodesWithColumns(this.state.columnGroups)?.filter(
        (e) => e.dataType
      );
    }

    if (this.chkArray(formatList)) {
      formatList.map((format) => {
        let filterList = bindingData.filter((e) =>
          Object.keys(e).includes(format.binding)
        );

        if (this.chkArray(filterList)) {
          this.makeDataType(filterList, format);
        }
      });
    }
    this.setState(
      {
        source: new CollectionView(bindingData, {
          sortDescriptions: this.state.sortDescriptions,
          groupDescriptions: this.state.groupDescriptions,
          trackChanges: this.state.trackChanges,
          pageSize: this.state.pageSize,
        }),
        rowCount: bindingData?.length,
      },
      () => {
        // grid auto size row

        setTimeout(() => {
          if (this.refGrid.current) _autoSizeRowsAsync(this.refGrid.current);
        }, 20);

        setTimeout(() => {
          // Tree 그리드 인 경우 행의 readonly 값 변경 (기본이 true)
          if (CHILDREN_ID && KEY1) {
            this.refGrid.current.rows.forEach((row) => {
              row.isReadOnly = false;
            });
          }
        }, 150);

        // 버퍼드 그리드일 경우
        if (
          this.props.pagingType === "Buffered" &&
          this.state.bufferedStartIndex !== 1
        ) {
          // this.refGrid.current?.collectionView?.moveCurrentToLast();
          // this.refGrid.current?.collectionView?.moveCurrentTo(70);

          // 사용자가 선택한 row index : 마우스 클릭 이벤트애서 추가
          // this.refGrid.current.select(this.state.selectedIndex, 0);
          this.refGrid.current.select(this.refSelectedIndex.current, 0);
          // scroll 위치 지정
          this.refGrid.current.scrollIntoView(
            this.state.bufferedStartIndex,
            0,
            false
          );
        } else {
          // 첫번째 줄 선택 해제
          this.refGrid.current?.collectionView?.moveCurrentToPosition(-1);
        }

        if (callback > "") callback(this);
      }
    );
  };

  // DataType에 맞춰서 Data Format 처리
  makeDataType(data, format) {
    if (format.dataType === "Date" || format.dataType === "Time") {
      data.map((e, idx) => {
        return (data[idx][format.binding] = e[format.binding]
          ? Globalize.format(
              new Date(e[format.binding]),
              format.format.replaceAll("/", "\\/")
            )
          : null);
      });
    } else if (format.dataType === "Number") {
      data.map((e, idx) => {
        return (data[idx][format.binding] = e[format.binding]
          ? Number(e[format.binding])
          : null);
      });
    } else if (format.dataType === "Boolean") {
      data.map((e, idx) => {
        return (data[idx][format.binding] = e[format.binding] ? true : false);
      });
    } else if (format.dataType === "String") {
      data.map((e, idx) => {
        return (data[idx][format.binding] = e[format.binding]
          ? e[format.binding]?.toString()
          : e[format.binding]);
      });
    }
  }

  setIsReadOnly = (value) => {
    this.setState({
      isReadOnly: value,
    });
  };

  getIsReadOnly = () => {
    if (this.state.isReadOnly) {
      return this.state.isReadOnly;
    }
  };

  /**
   * column Setting
   * @param columns
   */
  setColumns = (columns) => {
    this.setState({
      columns: columns,
    });
  };

  /**
   * column Group Setting
   * @param colgroup
   */
  setColumngroups = (colgroup) => {
    this.setState({
      columnGroups: colgroup,
    });
  };

  // 그리드 전체 데이터
  getRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.refGrid.current.rows.map((x) => x.dataItem);
    }
  };

  getRowsByIndex = (idx) => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.getRows()[idx];
    }
  };

  setCheckedRow = (idx, isChk = true) => {
    if (this.chkArray(this.refGrid.current.rows)) {
      const chkColumn = this.refGrid.current?.getColumn(
        this.props.checkBoxColumn
      );
      this.refGrid.current?.setCellData(idx, chkColumn.index, isChk);
    }
  };

  getCheckedRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.getRows().filter((e) => {
        return e[this.props.checkBoxColumn];
      });
    }
  };

  // 그리드 선택한 행 데이터
  getSelectedRow = () => {
    if (this.refGrid.current?.collectionView) {
      const currentItem = this.refGrid.current.collectionView?.currentItem;
      return currentItem || this.refGrid.current?.selectedItems[0];
    }
  };

  // 그리드 선택한 행 인덱스
  getSelectedRowIndex = () => {
    if (this.refGrid.current?.selectedRows) {
      return this.refGrid.current.selectedRows[0]?.index;
    }
  };

  // 그리드 rows 개수
  getRowsCount = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.refGrid.current.rows.length;
    } else {
      return 0;
    }
  };

  // 그리드 신규 추가한 데이터
  getAddedRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.getRows().filter((x) => {
        return x.ROW_STATUS === 1;
      });
    }
  };

  /// 그리드 수정한 데이터
  getEditedRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.getRows().filter((x) => {
        return x.ROW_STATUS === 2;
      });
    }
  };

  // 그리드 삭제한 데이터
  getDeletedRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      return this.getRows().filter((x) => {
        return x.ROW_STATUS === 4;
      });
    }
  };

  // 그리드 GetColumn
  getColumn = (column = "") => {
    if (this.refGrid.current) {
      return this.refGrid.current.getColumn(column);
    }
  };

  // 버퍼드 정보 바인딩
  setBufferedInfo(idx, cnt) {
    idx = idx ? Number(idx) : 1;
    cnt = cnt ? cnt : Number(this.state.bufferedDataCount);
    this.setState({
      bufferedStartIndex: idx,
      bufferedDataCount: cnt,
    });
  }
  getBufferedInfo() {
    return {
      idx: Number(this.state.bufferedStartIndex),
      cnt: Number(this.state.bufferedDataCount),
      size: Number(this.state.pageButtonCount),
      end: Number(this.state.bufferedEndIndex),
      cur: Math.ceil(
        this.state.bufferedStartIndex / this.state.bufferedDataCount
      ),
    };
  }
  setBufferedEndIndex(idx) {
    this.setState({
      bufferedEndIndex: Number(idx),
    });
  }

  setPageButtons(endIdx, param = null) {
    this.refProgramParam.current = param;

    const index = Number(this.state.bufferedStartIndex);
    const count = Number(this.state.bufferedDataCount);
    const totPageCnt = Math.ceil(endIdx / count);

    // making button count
    const btnCnt = Number(this.state.pageButtonCount);
    // current page
    const currentPage = Math.ceil((index - 1) / count) + 1;
    // start button index
    const startPage =
      (Math.ceil(Math.max(1, currentPage / btnCnt)) - 1) * btnCnt + 1;

    let pageNums = [];
    let activePageNums = [];

    // making button
    for (let i = 0; i < btnCnt; i++) {
      const curPageNum = startPage + i;
      if (curPageNum > totPageCnt) break;
      pageNums.push(curPageNum);
      // select button by current page
      if (curPageNum == currentPage) activePageNums.push(1);
      else activePageNums.push(0);
    }

    // if the data can't be found, then search the previous index
    if (
      endIdx !== 0 &&
      pageNums[pageNums.length - 1] < currentPage &&
      this.refSearchCnt.current < 3
    ) {
      // Ways to safeguard recursive func
      this.refSearchCnt.current = this.refSearchCnt.current + 1;
      // setting start index
      this.setState({
        bufferedStartIndex: (pageNums[pageNums.length - 1] - 1) * count + 1,
        bufferedDataCount: this.state.bufferedDataCount,
      });
      // searching program func by props search func
      this.props.bufferedSearchFunction(
        (pageNums[pageNums.length - 1] - 1) * count + 1
      );
      return;
    }

    const nowPage = activePageNums?.find((x) => x == 1);
    if (!nowPage) {
      if (activePageNums.length > 0) activePageNums[0] = 1;
      this.setState({
        bufferedStartIndex: 1,
        bufferedDataCount: this.state.bufferedDataCount,
      });
    }

    this.setState({
      pageButton: pageNums,
      activeButton: activePageNums,
      bufferedEndIndex: endIdx,
    });
  }

  /**
   *
   * @param {*} idx : search page index
   * @param {*} param : search parameter
   */
  setPageIndex(idx = 1, param) {
    let result = null;
    if (idx === 0) idx = 1;
    const START_INDEX = idx > 0 ? idx : this.state.bufferedStartIndex;
    const DATA_COUNT = this.state.bufferedDataCount;
    this.setBufferedInfo(START_INDEX, DATA_COUNT);

    if (Array.isArray(param)) {
      param?.forEach((item) => {
        item.START_INDEX = START_INDEX;
        item.DATA_COUNT = DATA_COUNT;
      });
      result = param;
    } else if (param && typeof param === "object") {
      param.START_INDEX = START_INDEX;
      param.DATA_COUNT = DATA_COUNT;
      result = param;
    } else {
      result = {
        OBJECT: param,
        START_INDEX: START_INDEX,
        DATA_COUNT: DATA_COUNT,
      };
    }

    return result;
  }

  getCurrentPosition() {
    return this.refGrid.current.collectionView.currentPosition;
  }

  setCurrentPosition(idx) {
    this.refGrid.current.collectionView.currentPosition = idx;
  }

  // Cell에 CSS 적용
  setToggleClass(cell, css, condition) {
    toggleClass(cell, css, condition);
  }

  setRemoveClass(cell, css) {
    removeClass(cell, css);
  }

  // 그리드 초기화
  clear = () => {
    this.setState({
      source: null,
      columns: [],
      columnGroups: [],
      bufferedEndIndex: null,
      rowCount: 0,
    });
  };
  clearDataBinding = (callback) => {
    this.setState({
      source: null,
      bufferedEndIndex: null,
      rowCount: 0,
    });

    if (callback) callback(this);
  };

  getColumnIndex = (c = null) => {
    if (!c) return -1;
    const column = this.refGrid.current.getColumn(c.toString());
    if (column) {
      return column.index;
    } else {
      return -1;
    }
  };

  // 행 추가
  addRow = (item = {}) => {
    // 맨마지막 행을 선택한 상태여야 행 추가시, 행 추가한 행이 화면에 보임
    const itemCount = this.getRowsCount();
    const view = this.refGrid.current.collectionView;
    if (!view) {
      console.error(
        "There is not binding in the Wijmo Grid. please excute the `setDataBinding()` function "
      );
      return;
    }
    view.currentPosition = itemCount - 1;

    // 행추가
    view.addNew();

    // 추가한 행의 상태는 1
    view.items[view.currentPosition].ROW_STATUS = 1;
    view.items[view.currentPosition].ROW_CHECK = true;
    Object.keys(item).forEach((key) => {
      view.items[view.currentPosition][key] = item[key];
    });

    // 이벤트 추가
    const e = new CellRangeEventArgs(
      this.refGrid.current.cells,
      this.refGrid.current.selection
    );
    this.refGrid.current.onRowAdded(e);

    return e;
  };

  // 행 삭제
  /**
   * 종속된 ( gird1에 의해 grid2가 출력된 화면에서 grid2일 경우 바로 적용이 안됨(스크롤 내려갔다가 올라가면 적용됨))
   */
  deleteRow = (idx) => {
    // idx가 없는 경우 마지막행을 대상으로 함
    if (idx !== 0 && !idx) {
      idx = this.getRowsCount() - 1;
    }

    // 신규로 추가된 행에 대해서는 행삭제를 진행
    // 기존 존재하는 행에 대해서는 삭제Flag 부여
    const rowStatus = this.refGrid.current.collectionView.items[idx].ROW_STATUS;

    if (this.props.isRowStatus == false || rowStatus == 1) {
      this.refGrid.current.collectionView.removeAt(Number(idx));
    } else {
      if (!rowStatus) {
        this.refGrid.current.collectionView.removeAt(Number(idx));
      } else if (rowStatus === 4) {
        this.refGrid.current.collectionView.items[idx].ROW_STATUS = "";
        this.refGrid.current.collectionView.items[idx].ROW_CHECK = false;
        this.viewUpdates();
      } else {
        // 삭제Flag 부여
        this.refGrid.current.collectionView.items[idx].ROW_STATUS = 4;
        this.refGrid.current.collectionView.items[idx].ROW_CHECK = true;
        this.viewUpdates();
      }
    }

    // 이벤트 추가
    let e = new CellRangeEventArgs(
      this.refGrid.current.cells,
      this.refGrid.current.selection
    );
    this.refGrid.current.onDeletingRow(e);

    return e;
  };

  // 그리드 선택 취소
  clearSelection = () => {
    if (this.refGrid.current?.collectionView) {
      this.refGrid.current.collectionView?.moveCurrentToPosition(-1);
    }
  };

  // 그리드 특정 행 선택
  selectionByIndex = (idx = 0) => {
    if (this.refGrid.current?.collectionView) {
      this.refGrid.current.collectionView?.moveCurrentToPosition(idx);
    }
  };

  // 그리드 신규 추가한 행 전부 삭제
  clearAddRows = () => {
    if (this.chkArray(this.refGrid.current.rows)) {
      this.getRows().map((e) => {
        if (e.ROW_STATUS === 1)
          return this.refGrid.current.collectionView?.remove(e);
      });
    }
  };

  // 배열 체크
  chkArray(arr) {
    if (arr && arr.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  chkValidate() {
    var returnValue = true;

    // // ERR_MSG 컬럼이 없으면 추가
    // //console.log(this.refGrid.current._cols.filter(c => c.binding === 'ERR_MSG').length)
    // if(this.refGrid.current._cols.filter(c => c.binding === 'ERR_MSG').length == 0) {
    //   var errMsg = { header: '오류 메시지', binding: 'ERR_MSG', width: 300, isReadOnly: true }
    //  this.refGrid.current._cols.push(errMsg);
    // }

    var rowCnt = this.getRowsCount();
    var colCnt = this.refGrid.current.columns.length;

    for (var i = 0; i < rowCnt; i++) {
      for (var j = 0; j < colCnt; j++) {
        var colId = this.refGrid.current._cols[j].binding;
        var colName = this.refGrid.current._cols[j].header;
        var value =
          this.refGrid.current.collectionView.sourceCollection[i][colId];
        var validInfo = this.state.validateInfo[colId];
        // yml 파일의 컬럼 ID와 현재 셀의 컬럼 ID가 동일하면 validate() 수행
        if (validInfo) {
          // validate() 수행 시 error를 throw하므로 try catch를 사용하여 ERR_MSG 컬럼에 값 바인딩
          try {
            validate(getValidateObject(validInfo, colName, value));
          } catch (ex) {
            this.refGrid.current.collectionView.sourceCollection[i].ERR_MSG =
              ex;
            returnValue = false;
          }
        }
      }
    }

    return returnValue;
  }

  setFlatColumnGroups(columnGroups) {
    if (columnGroups.length == 0) return [];
    var prev = columnGroups[0];
    var next = columnGroups.length === 1 ? [] : columnGroups.slice(1);
    if (Array.isArray(prev.columns)) {
      return this.setFlatColumnGroups(prev.columns.concat(next));
    } else {
      return [prev].concat(this.setFlatColumnGroups(next));
    }
  }

  // 컬럼 그룹 auto width & align center 지정
  settingColumnGroups(columnGroups) {
    if (!this.refColumnGroupsTemp.current?.length)
      this.refColumnGroupsTemp.current = _.cloneDeep(this.state.columnGroups);

    columnGroups.map((column) => {
      if (this.chkArray(column.columns)) {
        this.settingColumnGroups(column.columns);
      } else {
        this.settingColumnGroupsCommon(column);
      }

      if (column?.CHToolTip) {
        delete column.CHToolTip;
      }
    });
    return columnGroups;
  }

  // columns와 동일한 로직 구성
  // settingColumnGroups 함수에서 호출함
  settingColumnGroupsCommon(column) {
    if (!column.editor) {
      column.editor = this._makeEditor(column);
    }

    if (!column.cellTemplate) {
      column.cellTemplate = this._makeCellTemplate(column);
    }
    this._delUndefinedColumn(column, true);
  }

  forceUpdates = () => {
    this.setState({ source: this.getRows() });
    this.forceUpdate();
  };

  // forceUpdates를 하는 경우, data의 값이 json형태의 데이터로 교체가 됨 (setDataBinding에서는 CollectionView임)
  // CollectionView가 필요하여 viewUpdates를 추가함.
  // 추가로 currentPosition 값을 기억하게 하여 data 바인딩 후 적용함
  viewUpdates = (callback) => {
    var currentPosition = this.getSelectedRowIndex();
    let bindingData = this.getRows();
    this.setState(
      {
        source: new CollectionView(bindingData, {
          sortDescriptions: this.state.sortDescriptions,
          groupDescriptions: this.state.groupDescriptions,
          trackChanges: this.state.trackChanges,
        }),
      },
      () => {
        this.refGrid.current.collectionView.currentPosition = currentPosition;
        return callback ? callback(this) : null;
      }
    );
  };

  // 행 고정
  freezeRows = () => {
    if (this.refGrid.current) {
      this.refGrid.current.frozenRows =
        this.refGrid.current.frozenRows > 0 ? 0 : this.state.frozenRows;
    }
  };

  // 열 고정
  freezeColumns = () => {
    if (this.refGrid.current) {
      this.refGrid.current.frozenColumns =
        this.refGrid.current.frozenColumns > 0 ? 0 : this.state.frozenColumns;
    }
  };

  /**
   * 생선된 CellMaker 선택적 제거
   * @param {panel} s
   * @param {event} e
   */
  removeCellMaker = (s, e) => {
    /**
     * gird 내 button 사용 시, 조건에 맞지 않으면 버튼 제거
     * 향후 link, image에도 필요시 적용 필요
     *
     * init
     */
    const result = this.state.columns.filter((x) => {
      return x.exceptChkValue;
    });

    // 제외할 목록이 존재 시,
    if (result && result.length) {
      result.map((x) => {
        if (x.binding === s.columns[e.col].binding) {
          let item = s.rows[e.row].dataItem;

          // 제거 유무의 조건이 맞는지 체크 : return only true value
          const exceptChkValue =
            result.length > 0
              ? Object.entries(x.exceptChkValue)
                  .map(([key, value]) => {
                    return item[key] === value;
                  })
                  .filter((x) => x === true)
              : null;

          // key : value 비교했을때, 제외(true)하는 대상이라면
          if (exceptChkValue && exceptChkValue.length > 0) {
            // element가 있는지 체크
            if (e.cell.childElementCount > 0) {
              switch (e.cell.lastChild.nodeName) {
                case "BUTTON":
                  e.cell.innerHTML = s.getCellData(e.row, e.col);
                  break;
                default:
                  break;
              }
            }
          }
        }
      });
    }
    /**
     * gird 내 button 사용 시, 조건에 맞지 않으면 버튼 제거
     * 향후 link, image에도 필요시 적용 필요
     *
     * end
     */
  };

  /**
   * Grid Header Style 적용
   * @param {evnet} e
   */
  addHeaderStyle = (e) => {
    if (this.props.headerStyle?.length) {
      let row = e.row;
      let col = e.col;

      this.props.headerStyle.forEach((x) => {
        if (x.row === row && x.col === col) {
          // if (x.header === e.panel.getCellData(e.row, e.col)) {
          x.className?.forEach((name) => {
            // e.cell.style.setProperty(v.key, v.value);
            this.setToggleClass(e.cell, name, true);
          });
        }
      });
    }
  };

  /**
   * Grid Header addition 함수
   * @param {object} arrays
   * @param {object} option
   * @param {any} callback
   * @returns
   */
  pushHeader = (arrays = "", option = "", callback) => {
    if (arrays && !Array.isArray(arrays)) {
      console.error("the first parameter has to be an Array.");
      return;
    }
    const thisGrid = this.refGrid.current;
    if (!thisGrid) {
      console.error("the Wijmo Grid is not yet initialized or initializing.");
      return;
    }
    const isReadOnly = this.state.isReadOnly;

    if (!option) {
      option = [
        {
          binding: "TEMP",
          header: "TEMP",
          align: "center",
          width: 150,
          isReadOnly: isReadOnly,
        },
      ];
    }

    // checking, exist grid current
    if (thisGrid && thisGrid.columns) {
      // binding이 정의되지 않은 header 검색
      const notBinding = thisGrid.columns
        .map((x, idx) => {
          return x.binding ? -1 : idx;
        })
        .filter((x) => {
          return x !== -1;
        });

      // binding이 정의되지 않은 header 삭제
      notBinding.forEach((x) => {
        thisGrid.columns.removeAt(x);
      });
    }

    // header make
    const groupColumns = _findGroupNodes(option);
    if (groupColumns) {
      // const aa = this.settingColumnGroups(option);
      // const bb = this.setFlatColumnGroups(option);
      // thisGrid.columnGroups.push(option);
      // bb.forEach((x) => {
      //   thisGrid.columns.push(new wjGrid.ColumnGroup(x));
      // });

      console.error(`그룹컬럼 추가 로직이 없습니다.`);
      return;
    } else {
      if (Array.isArray(option)) {
        option?.forEach((x) => {
          thisGrid.columns.push(new wjGrid.Column(x));
        });
      }
    }
    // databinding
    this.setDataBinding(arrays);

    // callback
    if (callback) callback(this);
  };

  /**
   * Grid Header remake 함수
   * @param {object} arrays
   * @param {object} option
   * @param {any} callback
   */
  remakeHeader = (arrays = "", option = "", callback) => {
    if (arrays && !Array.isArray(arrays)) {
      console.error("the first parameter has to be an Array.");
      return;
    }
    const thisGrid = this.refGrid.current;
    if (!thisGrid) {
      console.error("the Wijmo Grid is not yet initialized or initializing.");
      return;
    }

    if (!option) {
      option = [
        {
          binding: "TEMP",
          header: "TEMP",
          align: "center",
          width: 150,
          isReadOnly: this.state.isReadOnly,
        },
      ];
    }

    // checking, exist grid current
    if (thisGrid && thisGrid.columns) {
      const notBinding = thisGrid.columns
        .map((x, idx) => {
          return x.binding ? -1 : idx;
        })
        .filter((x) => {
          return x !== -1;
        });

      // binding이 정의되지 않은 header 삭제
      notBinding.forEach((x) => {
        thisGrid.columns.removeAt(x);
      });
    }
    // binding이 정의되지 않은 header 검색

    // header make
    const groupColumns = _findGroupNodes(option);

    if (groupColumns) {
      /**
       * 일반컬럽에서 그룹컬럼으로 안바뀔수 있음
       */
      this.setColumngroups(this.settingColumnGroups(option));
    } else {
      /**
       * 그룹컬럼에서 일반컬럽으로 안바뀔수 있음
       */
      // this.setColumns(option);
      // normal column defined again
      thisGrid.columns.clear();
      option?.forEach((column) => {
        column.cellTemplate = this._makeCellTemplate(column);
        column.editor = this._makeEditor(column);

        const refactorColumn = this._delUndefinedColumn(column);
        thisGrid.columns.push(new wjGrid.Column(refactorColumn));
      });
    }

    // databinding
    this.setDataBinding(arrays);

    // callback
    if (callback) callback(this);
  };

  /**
   * remove function for the undefined column
   * you can change the properties of the received parameters using the `overwrite` property: true
   * @param {*} column
   * @param {*} overwrite
   * @returns
   */
  _delUndefinedColumn = (column, overwrite = false) => {
    const refactorColumn = overwrite ? column : _.cloneDeep(column);

    refactorColumn.width = refactorColumn.width ? refactorColumn.width : "*";
    refactorColumn.isReadOnly =
      refactorColumn.isReadOnly ?? this.state.isReadOnly;
    refactorColumn.align = refactorColumn.align ? refactorColumn.align : null;

    // use editor
    delete refactorColumn.multiSelect;
    delete refactorColumn.isTime;
    delete refactorColumn.timeStep;
    delete refactorColumn.isDateTime;
    delete refactorColumn.timeFormat;
    if (refactorColumn.dataMapCode) {
      refactorColumn.dataMap = new DataMap(
        refactorColumn.dataMap,
        refactorColumn.dataMapCode,
        refactorColumn.dataMapValue
      );
      delete refactorColumn.dataMapCode;
      delete refactorColumn.dataMapValue;
    }

    // use cellTemplate
    delete refactorColumn.isImage;
    delete refactorColumn.isLink;
    delete refactorColumn.clickEvent;
    delete refactorColumn.isButton;
    delete refactorColumn.isButtonIcon;
    delete refactorColumn.isButtonColor;
    delete refactorColumn.exceptChkValue;
    delete refactorColumn.dateSelectionMode;
    delete refactorColumn.multiSelect;

    return refactorColumn;
  };

  /**
   * defined for creating the cellTemplate using flexGridColumn
   * @param {*} column
   * @returns
   */
  _makeCellTemplate = (column = null) => {
    if (!column) return null;

    // button Icon, ColorType
    let btnClassNames = this._definedBtnCss(column);
    const cloneEvent = column.clickEvent;
    // make cell template
    const rtnCellTemplate = column.dataType?.inputColor
      ? '<span class="colorbox" style="background:${text};"></span> ${text}'
      : column.isButton
      ? CellMaker.makeButton({
          cssClass: btnClassNames,
          click: (e, ctx) => {
            if (cloneEvent) cloneEvent(e, ctx);
          },
        })
      : column.isImage
      ? CellMaker.makeImage({
          click: (e, ctx) => {
            if (cloneEvent) cloneEvent(e, ctx);
          },
        })
      : column.isLink
      ? CellMaker.makeLink({
          click: (e, ctx) => {
            if (cloneEvent) cloneEvent(e, ctx);
          },
        })
      : column.isFileTemplete
      ? '<span class="list_clip_icon"><span> ${text}'
      : null;

    return rtnCellTemplate;
  };

  /**
   * defined for creating the editor using flexGridColumn
   * @param {*} column
   * @returns
   */
  _makeEditor = (column) => {
    if (!column) return null;
    return column.dataType?.inputColor
      ? new InputColor(document.createElement("div"))
      : column.multiSelect?.showMulti
      ? new MultiSelect(document.createElement("div"), {
          showSelectAllCheckbox: column.multiSelect?.showSelectAll ?? false,
          showFilterInput: column.multiSelect?.showFilter ?? false,
          placeholder: column.multiSelect?.placeholder ?? "",
          maxHeaderItems: column.multiSelect?.maxItems ?? 3,
          selectedValuePath: column.multiSelect?.codeId ?? "codeId",
          displayMemberPath: column.multiSelect?.codeName ?? "codeName",
          headerPath: column.multiSelect?.codeName ?? "codeName",
          itemsSource: column.multiSelect?.dataMap ?? [],
        })
      : column.dataType == "Date" && column.isDateTime
      ? new InputDateTime(document.createElement("div"), {
          isRequired: column.isRequired ?? this.state.isRequired,
          value: null,
          format: column.format?.replaceAll("/", "\\/"),
          timeStep: column.timeStep,
          timeFormat: column.timeFormat,
        })
      : column.dataType == "Date" && column.isTime
      ? new InputTime(document.createElement("div"), {
          isRequired: column.isRequired ?? this.state.isRequired,
          value: null,
          format: column.format?.replaceAll("/", "\\/"),
          step: column.timeStep,
        })
      : column.dataType == "Date"
      ? new InputDate(document.createElement("div"), {
          isRequired: column.isRequired ?? this.state.isRequired,
          value: null,
          format: column.format?.replaceAll("/", "\\/"),
          selectionMode: Number(
            column.dateSelectionMode ? column.dateSelectionMode : 1
          ),
        })
      : column.dataMap
      ? !(column.dataMapEditor === "RadioButtons")
        ? new AutoComplete(document.createElement("div"), {
            itemsSource: column.dataMap,
            selectedValuePath: column.dataMapCode,
            displayMemberPath: column.dataMapValue,
            minLength: 1,
            selectedIndexChanged: (sender, s, e) => {
              if (sender.inputElement.ariaExpanded === "true")
                setImmediate(() => sender.inputElement.blur());
            },
          })
        : null
      : null;
  };

  /**
   * defined for creating the CSS for the button using flexGridColumn
   * using: this._makeCellTemplate(column)
   * @param {*} column
   * @returns
   */
  _definedBtnCss = (column) => {
    let btnClassNames = [btnStyles.btn];
    if (column.isButtonIcon) {
      btnClassNames.push(btnStyles.icon);
      btnClassNames.push(btnStyles[column.isButtonIcon]);
    }
    if (column.isButtonColor)
      btnClassNames.push(btnStyles[column.isButtonColor]);
    btnClassNames = btnClassNames.join(" ");

    return btnClassNames;
  };

  /**
   * Grid Header subtraction by index 함수
   * @param {Number} index
   * @param {any} callback
   */
  removeHeaderByIndex = (index = 0, callback) => {
    const thisGrid = this.refGrid.current?.columns;

    // header delete
    thisGrid?.removeAt(index);

    // callback
    if (callback) callback(this);
  };

  /**
   * Grid Header subtraction by column 함수
   * @param {string} columnName
   * @param {object} callback
   */
  removeHeaderByColumn = (columnName = "", callback) => {
    const thisGrid = this.refGrid.current?.columns;

    // filter for delete column list
    thisGrid
      .filter((x) => {
        return x.binding == columnName;
      })
      .forEach((item) => {
        thisGrid?.remove(item);
      });

    // callback
    if (callback) callback(this);
  };

  /**
   * Change Grid DropDown Editor 함수
   * @param {string} _column
   * @param {object} _dataMap
   * @param {string} _dataMapCode
   * @param {string} _dataMapValue
   * @param {boolean} _firstSelected
   * @param {any} callback
   */
  setDropDown = (
    _column = "",
    _dataMap = [],
    _dataMapCode = "codeId",
    _dataMapValue = "codeName",
    _firstSelected = false,
    callback
  ) => {
    if (!_column) {
      console.error(
        "the first parameter is missing the column name( required `_column` )."
      );
      return;
    }

    // flex Grid
    const flexGrid = this.refGrid.current;
    if (flexGrid) {
      // flex Grid Column
      const flexGridColumn = flexGrid.getColumn(_column);

      // make dataMap
      flexGridColumn.dataMap = new DataMap(
        _dataMap,
        _dataMapCode,
        _dataMapValue
      );

      // change DropDown (다른 DataMap이 세팅 되어 있을 경우 신규 dataMap으로 수정하기 위한 용도)
      const dropDown = DropDown.getControl(flexGridColumn.editor?.dropDown);
      if (dropDown) dropDown.itemsSource = _dataMap;

      // 신규 dataMap의 첫번째 값
      let firstValue = "";
      if (_dataMap.length > 0 && _firstSelected) {
        firstValue = _dataMap[0][_dataMapCode];
      }

      // 기존에 데이터가 바인딩 되어 있다면 신규 dataMap의 값으로 변경
      flexGrid?.rows?.forEach((item, index) => {
        const data = item?.dataItem[_column];
        flexGrid.setCellData(
          index,
          flexGridColumn.index,
          data ?? firstValue,
          false,
          false
        );
      });

      // callback
      if (callback) callback(this);
    } else {
      console.error("the Wijmo Grid is not yet initialized or initializing.");
      return;
    }
  };

  /**
   *
   * @param {number} e : row
   * @param {number | string} t : col
   * @param {any} i : value
   * @param {any} callback : callback
   * @param {boolean} o : coerce
   * @param {boolean} n : invalidate
   * @param {boolean} v : isMapKeyValue
   * @returns
   */
  setCellData = (e, t, i, callback, o = false, n = false, v = false) => {
    this.refGrid.current?.setCellData(e, t, i, o, n, v);
    // callback
    if (callback) callback(this);
  };

  /**
   * 내부함수. 외부에서 호출 X
   * @param {*} leftWrap
   * @param {*} rightWrap
   * @returns
   */
  CreateGridTop(leftWrap, rightWrap) {
    if (rightWrap && rightWrap.btnExcel && !rightWrap.btnExcel.onClick) {
      rightWrap.btnExcel.onClick = (menuName) => {
        const now = new Date();
        const strDate = getDate2String(now, "yyyyMMddHHddss");
        this.saveExcel(
          true,
          true,
          (menuName ?? "sheet") + "_" + strDate + ".xlsx"
        );
      };
    }
    let cnts = 0;
    const leftComponents = leftWrap
      ? Object.keys(leftWrap).filter((x) => x != "cnt").length
      : 0;
    if (leftWrap.cnt) cnts++;
    if (leftWrap && Object.keys(leftWrap).filter((x) => x != "cnt").length)
      cnts++;
    if (rightWrap && Object.keys(rightWrap).length) cnts++;

    return cnts + leftComponents ? (
      <div className={styles.wjLeftRightWrap}>
        {leftWrap && (
          <>
            <div className={styles.wjConLeftWrap}>
              {leftWrap.title && (
                <span className="divTitle">{leftWrap.title}</span>
              )}
              {leftWrap.cnt && (
                <>
                  <span className="divTitle_count">
                    {this.state.bufferedEndIndex ?? this.state.rowCount}
                  </span>
                  <p>건</p>
                </>
              )}
            </div>
            {leftComponents > 0 && <div>{createBtnArea({ ...leftWrap })}</div>}
          </>
        )}
        {rightWrap && (
          <div className={styles.wjConRightWrap}>
            {createBtnArea({ ...rightWrap })}
          </div>
        )}
      </div>
    ) : (
      <div className={styles.wjConRightWrap}></div>
    );
  }

  // change edit mode when one click cell
  startEditing(s, e) {
    const flex = this.refGrid.current;
    if (flex) {
      const index = flex.selection.col;
      const col = index > -1 ? flex.columns[index] : null;
      if (
        col &&
        !col.isReadOnly &&
        col.dataType !== DataType.Boolean &&
        !col.dataMap
      ) {
        // setTimeout(() => {
        //   flex.startEditing(false); // quick mode
        // }, 50); // let the grid update first
        if (e.row > -1 && e.col > -1) s.startEditing(true, e.row, e.col);
      }
    }
  }

  _initializedPicker(picker) {
    const host = picker.hostElement;

    // picker 실행 안되게 처리
    if (!this.props.isAllowListBox) {
      return;
    }
    host.addEventListener("dragstart", _handleDragStart);
    host.addEventListener("dragover", _handleDragOver);
    host.addEventListener("drop", _handleDrop);
    host.addEventListener("dragend", _handleDragEnd);
    this.columnPicker.current = picker;
    this.columnPicker.current.itemsSource =
      this.refGrid.current.columns?.filter((x) => {
        return x.visible !== false;
      });
    this.columnPicker.current.checkedMemberPath = "visible";
    this.columnPicker.current.displayMemberPath = "header";

    this.columnPicker.current.lostFocus.addHandler(() => {
      hidePopup(this.columnPicker.current.hostElement);
    });
    this.columnPicker.current.formatItem.addHandler((s, e) => {
      _handleEnableDragItem(e.item, true);
    });
  }

  /**
   * flexGrid 관련 함수
   *
   * end
   */

  /**
   * Excel 관련 함수
   *
   * init
   */

  /**
   *
   * @param {Boolean} colHeader colHeader 생성 여부
   * @param {Boolean} style style 적용 여부
   * @param {*} fileName 파일 이름
   * @param {Boolean} isCheckedItem 체크된 항목 export 여부
   * 엑셀 Export
   *
   */
  saveExcel = (colHeader, style, fileName, isCheckedItem = false) => {
    const copyGrid = _.cloneDeep(this.refGrid.current);
    if (copyGrid) {
      if (isCheckedItem) {
        const trueValue = copyGrid.itemsSource.filter((x) => {
          return x.ROW_CHECK === true;
        });

        copyGrid.itemsSource = trueValue;
      }

      const exportFormatItem = (args) => {
        let p = args.panel,
          row = args.row,
          col = args.col,
          xlsxCell = args.xlsxCell,
          cell;

        // cell 상하 가운데 정렬
        xlsxCell.style.vAlign = 1;
        if (p.cellType === CellType.Cell) {
          if (
            p.columns[col].name === "excelFormat" &&
            p.rows[row] instanceof GroupRow
          ) {
            // 그리드에 보여지는 값으로 엑셀 값 출력
            cell = args.getFormattedCell();
            xlsxCell.value = cell.textContent.trim();
          }
        }
      };

      wjcGridXlsx.FlexGridXlsxConverter.saveAsync(
        copyGrid,
        {
          includeColumnHeaders: colHeader,
          includeStyles: style,
          includeColumns: function (column) {
            return (
              column.binding !== "ROW_CHECK" &&
              column.binding !== "ROW_STATUS" &&
              column.visible
            );
          },
          formatItem: exportFormatItem,
        },
        fileName > "" ? fileName : "FlexGrid.xlsx"
      );

      copyGrid.itemsSource = this.refGrid.current.itemsSource;
    }
  };

  // 엑셀 Import
  loadExcel = (headeRangeIdx = 0, callBack = "") => {
    this.useRefInput.current["headeRangeIdx"] = headeRangeIdx;
    this.useRefInput.current["callBack"] = callBack;
    this.useRefInput.current.click();
  };

  loadExcelMakeGridData = async (file, notMerge) => {
    let grid = this.refGrid.current;
    let _workbook = new wjcXlsx.Workbook();
    _workbook.loadAsync(file, (workbook) => {
      let headeRangeIdx = this.useRefInput.current["headeRangeIdx"];
      let sheet = workbook.sheets[0];
      let excelRow = sheet.rows[0];
      let newData = this.getImportedDataFromWorkSheet(
        sheet,
        grid,
        headeRangeIdx,
        notMerge
      );

      // newData 구조가 헤더명:값 으로 되어 있어, 헤더명을 컬럼ID로 변경함
      let arrData = new Array();
      const gridColumnsCopy = _.cloneDeep(grid._cols).filter((x) => {
        return x.binding !== "ROW_CHECK" && x.binding !== "ROW_STATUS";
      });

      for (let i = 0; i < newData.length; i++) {
        let j = 0;
        let objData = new Object();

        for (let [key, val] of newData[i]) {
          // 엑셀 데이터에 '가 있는경우 제거
          let value = val;
          value =
            typeof value == "string"
              ? value.substring(0, 1) === "'"
                ? value.substring(1)
                : value
              : value;

          objData[gridColumnsCopy[j]?.binding] = value;
          j++;
        }
        arrData.push(objData);
      }

      this.state.source = arrData;
      this.setDataBinding(arrData, () => {
        if (this.useRefInput.current?.callBack > "")
          this.useRefInput.current?.callBack(this);
      });
      if (this.useRefInput.current.value !== null)
        this.useRefInput.current.value = "";
    });
  };

  getImportedDataFromWorkSheet(
    worksheet,
    flexGrid,
    headeRangeIdx = 0,
    notMerge
  ) {
    const idx = headeRangeIdx;
    let data = [],
      workSheetRows = worksheet.rows.slice(idx + 1);

    let rowHeader = [];
    let hColSpan = undefined;
    let hColSpanCnt = 1;
    for (let i = 0; i < idx + 1; i++) {
      let cells = worksheet.rows[i].cells;
      for (let j = 0; j < cells.length; j++) {
        if (cells[j]?.colSpan) {
          hColSpan = cells[j]?.colSpan;
          hColSpanCnt = 1;
        }
        if (cells[j]?.value || (hColSpan >= 1 && hColSpan - hColSpanCnt >= 0)) {
          rowHeader[j] = cells[j];
        }

        if (hColSpan >= 1 && hColSpan - hColSpanCnt === 0) {
          hColSpan = undefined;
          hColSpanCnt = 1;
        }
        if (hColSpan >= 1 && hColSpan - hColSpanCnt > 0) hColSpanCnt++;
      }
    }

    let cellMergeTmp = [];

    workSheetRows.forEach((drow) => {
      let cells = drow.cells;
      const _item = new Map();

      // 배열의 null 값 제거
      let chkArr = cellMergeTmp.filter(Boolean);

      if (!chkArr.length) {
        // cell에 rowSpan이 존재한다면 temp에 넣어줌
        cells.forEach((x, idx) => {
          if (x.rowSpan) {
            cellMergeTmp[idx] = {
              rowSpan: x.rowSpan,
              rowSpanCnt: 0,
              value: x.value,
            };
          }
        });
      }

      rowHeader.forEach((row, i) => {
        if (!notMerge) {
          // rowSpan (merge) 가 존재할 경우
          if (cellMergeTmp[i]) {
            // rowSpanCnt를 했을때 아직까지 merge 대상일 경우
            if (cellMergeTmp[i]?.rowSpan !== cellMergeTmp[i]?.rowSpanCnt) {
              // 해당 행에 데이터를 넣어줌 (temp에 담아놓은 데이터)
              // ∵ 엑셀에 merge되어있을경우 merge된 셀에 데이터는 하나밖에 없기 때문에 모든 row에 같은 값을 넣어줌
              // e3 framework에서는 같은 값일 경우 merge하는 기능이 존재
              _item.set(row.value, cellMergeTmp[i]?.value);
              cellMergeTmp[i].rowSpanCnt = cellMergeTmp[i].rowSpanCnt + 1;
            }

            // merge 대상이 끝났다면 삭제를 위한 null 셋팅
            if (cellMergeTmp[i]?.rowSpan === cellMergeTmp[i]?.rowSpanCnt) {
              cellMergeTmp[i] = null;
            }
          } else {
            _item.set(row.value, cells[i]?.value);
          }
        } else {
          _item.set(row.value + i, cells[i]?.value);
        }
      });
      data.push(_item);
    });
    return data;
  }

  /**
   * Excel 관련 함수
   *
   * end
   */
}

/* #region 이동현 추가 */
E3WijmoGrid.prototype.moveUp = function () {
  const old_index = this.getCurrentPosition();
  if (old_index <= 0) {
    return;
  }

  const new_index = old_index - 1;

  this.refGrid.current.rows.splice(
    new_index,
    0,
    this.refGrid.current.rows.splice(old_index, 1)[0]
  );

  this.viewUpdates();

  const timer = setTimeout(() => {
    this.setCurrentPosition(new_index);
  }, 30);
  return () => clearTimeout(timer);
};

E3WijmoGrid.prototype.moveDown = function () {
  const old_index = this.getCurrentPosition();
  const new_index = old_index + 1;

  if (old_index == -1 || this.refGrid.current.rows.length <= new_index) {
    return;
  }

  this.refGrid.current.rows.splice(
    new_index,
    0,
    this.refGrid.current.rows.splice(old_index, 1)[0]
  );

  this.viewUpdates();

  const timer = setTimeout(() => {
    this.setCurrentPosition(new_index);
  }, 30);
  return () => clearTimeout(timer);
};

// ROW_CHECK 컬럼이 true인 row 삭제 또는 ROW_STATUS 변경

E3WijmoGrid.prototype.deleteCheckedRow = function () {
  for (let i = this.refGrid.current.rows.length - 1; 0 <= i; i--) {
    const item = this.refGrid.current.rows[i].dataItem;
    if (item.ROW_CHECK) {
      this.deleteRow(i);
    }
  }
};

E3WijmoGrid.prototype.setCheckAll = function (isCheck) {
  const view = this.refGrid.current.collectionView;
  for (let i = 0; i < view.sourceCollection.length; i++) {
    view.sourceCollection[i].ROW_CHECK = isCheck;
  }

  this.viewUpdates();
};
/* #endregion 이동현 추가 */

E3WijmoGrid.propTypes = {
  style: PropTypes.object,
  theme: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  columns: PropTypes.array.isRequired,
  columnGroups: PropTypes.array,
  allowAddNew: PropTypes.bool,
  allowDelete: PropTypes.bool,
  selectionMode: PropTypes.string,
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  onHeaderClick: PropTypes.func,
  onHeaderDoubleClick: PropTypes.func,
  sortDescriptions: PropTypes.array,
  groupDescriptions: PropTypes.array,
  trackChanges: PropTypes.bool,
  filter: PropTypes.bool,
  quickAutoSize: PropTypes.bool,
  allowPinning: PropTypes.string,
  isNo: PropTypes.bool,
  codeId: PropTypes.string,
  frozenRows: PropTypes.number,
  frozenColumns: PropTypes.number,
  allowMerging: PropTypes.string,
  isReadOnly: PropTypes.bool,
  exportExcel: PropTypes.bool,
  defaultColumn: PropTypes.bool,
  onCellUpdate: PropTypes.func,
  onCellEditEnding: PropTypes.func,
  onCellEditEnded: PropTypes.func,
  onRowAdded: PropTypes.func,
  onDeletingRow: PropTypes.func,
  prepareCellForEdit: PropTypes.func,
  beginningEdit: PropTypes.func,
  sortedColumn: PropTypes.func,
  isAllCheckbox: PropTypes.bool,
  checkBoxColumn: PropTypes.string,
  validateYmlFile: PropTypes.string,
  gridId: PropTypes.string,
  isBuffered: PropTypes.bool,
  pagingType: PropTypes.string,
  bufferedStartIndex: PropTypes.number,
  bufferedDataCount: PropTypes.number,
  bufferedSearchFunction: PropTypes.func,
  pageSize: PropTypes.number,
  pageButtonCount: PropTypes.number,
  isRestrictedMergeManager: PropTypes.bool,
  childItemsPath: PropTypes.string,
  isCollapseGroupsToLevel0: PropTypes.bool,
  onloadedRows: PropTypes.func,
  onFormatItem: PropTypes.func,
  onDraggedRow: PropTypes.func,
  isColumnFooters: PropTypes.bool,
  isInputFilter: PropTypes.bool,
  isSearchFilter: PropTypes.object,
  isDragColumn: PropTypes.bool,
  isDragComboBoxCheck: PropTypes.bool,
  isAutoRowHeights: PropTypes.bool,
  headerStyle: PropTypes.array,
  columnFooterName: PropTypes.object,
  exportFileName: PropTypes.string,
  isContextMenu: PropTypes.bool,
  onCopying: PropTypes.func,
  onPasted: PropTypes.func,
  onPastedCell: PropTypes.func,
  onPasting: PropTypes.func,
  onPastingCell: PropTypes.func,
  cssClass: PropTypes.object,
  autoGenerateColumns: PropTypes.bool,
  headersVisibility: PropTypes.string,
  leftWrap: PropTypes.object,
  isHdrTooltip: PropTypes.bool,
  isTooltip: PropTypes.bool,
  oneClickEdit: PropTypes.bool,
  isRequired: PropTypes.bool,
  isMultiLine: PropTypes.bool,
  isWordWrap: PropTypes.bool,
  isAllowSorting: PropTypes.bool,
  isAllowDragging: PropTypes.bool,
  isUpdateCheck: PropTypes.bool,
  notMerge: PropTypes.bool,
  keyPath: PropTypes.string,
  isAllowListBox: PropTypes.bool,
};

E3WijmoGrid.defaultProps = {
  width: "100%",
  height: "100%",
  columns: [],
  columnGroups: [],
  allowAddNew: false,
  allowDelete: true,
  selectionMode: "Row",
  onRowClick: null,
  onRowDoubleClick: null,
  onHeaderClick: null,
  onHeaderDoubleClick: null,
  sortDescriptions: [],
  groupDescriptions: [],
  trackChanges: true,
  filter: false,
  quickAutoSize: true,
  allowPinning: "",
  isNo: true,
  frozenRows: 0,
  frozenColumns: 0,
  allowMerging: "Cells",
  isReadOnly: true,
  exportExcel: false,
  defaultColumn: false,
  onCellUpdate: null,
  onCellEditEnding: null,
  onCellEditEnded: null,
  onRowAdded: null,
  onDeletingRow: null,
  prepareCellForEdit: null,
  beginningEdit: null,
  sortedColumn: null,
  isAllCheckbox: false,
  checkBoxColumn: "CHK",
  validateYmlFile: null,
  gridId: null,
  isBuffered: false,
  pagingType: "None", // Buffered, Server
  bufferedStartIndex: 1,
  bufferedDataCount: 1000,
  bufferedSearchFunction: null,
  pageSize: 0,
  pageButtonCount: 10,
  isRestrictedMergeManager: false,
  childItemsPath: "",
  isCollapseGroupsToLevel0: false,
  onloadedRows: null,
  onFormatItem: null,
  onDraggedRow: null,
  isColumnFooters: false,
  isInputFilter: false,
  isSearchFilter: null,
  isDragColumn: false,
  isDragComboBoxCheck: true,
  isAutoRowHeights: false,
  headerStyle: [],
  columnFooterName: {},
  exportFileName: "",
  isContextMenu: true,
  onCopying: null,
  onPasted: null,
  onPastedCell: null,
  onPasting: null,
  onPastingCell: null,
  cssClass: null,
  autoGenerateColumns: false,
  headersVisibility: "Column", // ['ALL','None','Column','Row']
  leftWrap: { cnt: false },
  isHdrTooltip: false,
  isTooltip: false,
  oneClickEdit: true,
  isRequired: false,
  isMultiLine: false,
  isWordWrap: false,
  isAllowSorting: true,
  isAllowDragging: true,
  isUpdateCheck: false,
  notMerge: false,
  keyPath: "MENU_ID",
  isAllowListBox: true,
};

class RestrictedMergeManager extends wjGrid.MergeManager {
  getMergedRange(p, r, c, clip = true) {
    // create basic cell range
    let rng = null;

    // start with single cell5
    rng = new wjGrid.CellRange(r, c);

    // 컬럼 헤더일 경우
    if (p.cellType === CellType.ColumnHeader) {
      if (
        !p.columns[c]?._ownerList?._owner?.allowMerging &&
        !p.columns[c].allowMerging
      )
        return rng;

      // 왼쪽/오른쪽 merge
      for (let i = rng.col; i < p.columns.length - 1; i++) {
        if (
          p.getCellData(rng.row, i, true) != p.getCellData(rng.row, i + 1, true)
        )
          break;
        rng.col2 = i + 1;
      }
      for (let i = rng.col; i > 0; i--) {
        if (
          p.getCellData(rng.row, i, true) != p.getCellData(rng.row, i - 1, true)
        )
          break;
        rng.col = i - 1;
      }

      // 위/아래 merge
      for (let i = rng.row; i < p.rows.length - 1; i++) {
        if (
          p.getCellData(i, rng.col, true) != p.getCellData(i + 1, rng.col, true)
        )
          break;
        rng.row2 = i + 1;
      }
      for (let i = rng.row; i > 0; i--) {
        if (
          p.getCellData(i, rng.col, true) != p.getCellData(i - 1, rng.col, true)
        )
          break;
        rng.row = i - 1;
      }
    }
    // 셀일 경우
    else if (p.cellType === CellType.Cell) {
      // 머지 대상만 머지 함
      if (!p.columns[c].allowMerging) return rng;

      // 버그가 많아서 value 값이 없을때 merge cancel
      const item = p.getCellData(r, c, true);
      if (item === 0 || item === "" || item === null) return rng;

      // get reference values to use for merging
      let val = p.getCellData(r, c, false);
      let checkCols = (dir) => {
        let state = true;
        for (let i = 0; i < c - 1; i++) {
          let cval = p.getCellData(r, i, false);
          let bcval =
            dir == "up"
              ? p.getCellData(rng.row - 1, i, false)
              : p.getCellData(rng.row2 + 1, i, false);
          if (p.columns[i].allowMerging && bcval != cval) {
            state = false;
            break;
          }
        }
        return state;
      };

      // expand up
      while (
        rng.row > 0 &&
        p.getCellData(rng.row - 1, c, false) == val &&
        checkCols("up")
      ) {
        rng.row--;
      }

      // expand down
      while (
        rng.row2 < p.rows.length - 1 &&
        p.getCellData(rng.row2 + 1, c, false) == val &&
        checkCols("down")
      ) {
        rng.row2++;
      }

      let rightCnt = 1;

      // expand left/right
      for (let i = rng.col; i < p.columns.length - 1; i++) {
        if (
          p.getCellData(rng.row, i, true) != p.getCellData(rng.row, i + 1, true)
        )
          break;
        if (!p.columns[c + rightCnt].allowMerging) break;

        rightCnt++;
        rng.col2 = i + 1;
      }

      let leftCnt = 1;
      for (let i = rng.col; i > 0; i--) {
        if (
          p.getCellData(rng.row, i, true) != p.getCellData(rng.row, i - 1, true)
        )
          break;
        if (!p.columns[c - leftCnt].allowMerging) break;

        //dps200
        // if (r === 2 && c === 5) {
        //   if (rng.row === 2 && rng.row2 === 3 && rng.col === 5 && rng.col2 === 7) {
        //     break;
        //   }
        // }

        leftCnt++;
        rng.col = i - 1;
      }

      //
      // don't bother with single-cell ranges
      if (rng.isSingleCell) {
        rng = null;
      }
    }

    // done
    return rng;
  }
}

/**
 * columns 목록만 들고오는 재귀함수
 * @param {*} nodes
 * @param {*} result
 * @returns
 */
const _findNodesWithColumns = (nodes, result = [], allPush = false) => {
  nodes.forEach((node) => {
    if (!node.columns) {
      result.push(node);
    } else if (allPush) {
      result.push(node);
    }

    if (node.columns && node.columns.length > 0) {
      _findNodesWithColumns(node.columns, result);
    }
  });

  return result;
};

/**
 * column인지 group column 인지 체크
 * column : false
 * group column : true
 * @param {*} nodes
 * @returns
 */
const _findGroupNodes = (nodes) => {
  let bool = false;

  if (Array.isArray(nodes)) {
    nodes.forEach((node) => {
      if (node.columns) {
        bool = true;
      }
    });
  } else {
    if (nodes.columns) {
      bool = true;
    }
  }

  return bool;
};

/**
 * grid auto size row
 * @param {*} grid
 * @param {*} rowIndex
 */
const _autoSizeRowsAsync = (grid, rowIndex) => {
  // row height 테스트
  if (rowIndex != null) {
    grid.rows[rowIndex].height = 35;
  } else {
    grid.rows.forEach((row) => (row.height = 35));
  }

  grid.onScrollPositionChanged();
};

const _handleDragStart = (e) => {
  dragSrc.current = closest(e.target, ".wj-listbox-item");
  if (dragSrc.current && e.dataTransfer) {
    e.dataTransfer.setData("text", dragSrc.current.innerHTML);
    e.dataTransfer.effectAllowed = "move";
  }
};
const _handleDragOver = (e) => {
  const dragOver = closest(e.target, ".wj-listbox-item");
  if (dragDst.current && dragDst.current !== dragOver) {
    removeDropMarker();
  }
  if (dragOver && dragOver !== dragSrc.current) {
    e.preventDefault();
    if (dragSrc.current && e.dataTransfer) {
      e.dataTransfer.dropEffect = "move";
      dragDst.current = dragOver;
      const src = getElementIndex(dragSrc.current);
      const dst = getElementIndex(dragDst.current);
      removeDropMarker();
      addDropMarker(dst > src);
    }
  } else {
    dragDst.current = null;
  }
};
const _handleDrop = (e) => {
  if (dragSrc.current && dragDst.current) {
    e.preventDefault();
    const src = getElementIndex(dragSrc.current);
    const dst = getElementIndex(dragDst.current);
    flexRef.current.columns.moveElement(src, dst);
  }
};
const _handleDragEnd = () => {
  dragSrc.current = null;
  dragDst.current = null;
  removeDropMarker();
};

const _handleEnableDragItem = (item, enabled) => {
  item.setAttribute("draggable", enabled.toString());
};

export default E3WijmoGrid;
